import "./MyLearningPage.scss";

import WelcomeBanner from "components/Banners/WelcomeBanner";
import React from "react";
import { useIntl } from "react-intl";

import myLearningImg from "static/icons/medium-collaboration-my-learning.jpg";
import waterImg from "static/icons/water.jpg";
import MyLearningOptions from "./MyLearningOptions";

const MyLearningPage = () => {
    const intl = useIntl();

    return (
        <div>
            <WelcomeBanner
                backgroundImgUrl={waterImg}
                title={intl.formatMessage({
                    id: "my_learning.welcome_banner.title",
                })}
                description={intl.formatMessage({
                    id: "my_learning.welcome_banner.description",
                })}
                displayImgUrl={myLearningImg}
            />
            <MyLearningOptions />
        </div>
    );
};

export default MyLearningPage;
